import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Products from 'merchandise-lib/constants/Product';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
import { logRavenException } from '../../utils/errors';
import { trackFailedApiNameMap } from '../../utils/metricUtils';
export const i18nKeysByUpgradeProduct = {
  [UpgradeProducts.SALES_PRO]: 'salesPro',
  [UpgradeProducts.SALES_STARTER]: 'salesStarter',
  [UpgradeProducts.SALES_PROFESSIONAL]: 'salesProfessional',
  [UpgradeProducts.SALES_ENTERPRISE]: 'salesEnterprise',
  [UpgradeProducts.SUITE_STARTER]: 'suiteStarter',
  [UpgradeProducts.SUITE_PROFESSIONAL]: 'suiteProfessional',
  [UpgradeProducts.SUITE_ENTERPRISE]: 'suiteEnterprise',
  [UpgradeProducts.MARKETING_STARTER]: 'marketingStarter',
  [UpgradeProducts.MARKETING_STARTER_EMAIL]: 'marketingStarterEmail',
  [UpgradeProducts.MARKETING_BASIC]: 'marketingBasic',
  [UpgradeProducts.MARKETING_PRO]: 'marketingProfessional',
  [UpgradeProducts.MARKETING_ENTERPRISE]: 'marketingEnterprise',
  [UpgradeProducts.MARKETING_PLUS_PROFESSIONAL]: 'marketingPlusProfessional',
  [UpgradeProducts.MARKETING_PLUS_ENTERPRISE]: 'marketingPlusEnterprise',
  [UpgradeProducts.SERVICE_STARTER]: 'serviceStarter',
  [UpgradeProducts.SERVICE_PROFESSIONAL]: 'serviceProfessional',
  [UpgradeProducts.SERVICE_ENTERPRISE]: 'serviceEnterprise',
  [UpgradeProducts.OPERATIONS_STARTER]: 'operations-starter',
  [UpgradeProducts.OPERATIONS_PROFESSIONAL]: 'operations-professional',
  [UpgradeProducts.OPERATIONS_ENTERPRISE]: 'operations-enterprise',
  [UpgradeProducts.ADS]: 'ads',
  [UpgradeProducts.WEBSITE]: 'website',
  [UpgradeProducts.REPORTING]: 'reporting',
  [UpgradeProducts.DEDICATED_IP]: 'dedicatedIp',
  [UpgradeProducts.TRANSACTIONAL_EMAIL]: 'transactionalEmail',
  [UpgradeProducts.ADDITIONAL_ACCOUNT]: 'additionalAccount',
  [UpgradeProducts.DESIGNATED_TECHNICAL_SUPPORT]: 'designatedTechnicalSupport',
  [UpgradeProducts.IN_PERSON_TRAINING]: 'inPersonTraining',
  [UpgradeProducts.ENTERPRISE]: 'enterprise',
  [UpgradeProducts.CMS_ENTERPRISE]: 'cmsEnterprise',
  [UpgradeProducts.CMS_PROFESSIONAL]: 'cmsProfessional',
  [UpgradeProducts.CMS_STARTER]: 'cmsStarter',
  [UpgradeProducts.CUSTOM_SSL]: 'customSsl',
  [UpgradeProducts.DOMAINS_LIMIT_INCREASE]: 'domains-limit-increase',
  [UpgradeProducts.SANDBOX_LIMIT_INCREASE]: 'sandbox-limit-increase',
  [UpgradeProducts.CALLING_LIMIT_INCREASE]: 'calling-limit-increase',
  [UpgradeProducts.PHONE_LIMIT_INCREASE]: 'phone-limit-increase',
  [UpgradeProducts.TEAMS_LIMIT_INCREASE]: 'teams-limit-increase',
  [UpgradeProducts.WHATSAPP_LIMIT_INCREASE]: 'whatsapp-limit-increase',
  [UpgradeProducts.VIDEO_LIMIT_INCREASE]: 'video-limit-increase',
  [UpgradeProducts.MARKETING_SMS_ADDON]: 'marketing-sms',
  [UpgradeProducts.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [UpgradeProducts.STARTER_CONTACTS]: 'starter-contacts',
  [UpgradeProducts.ESIGNATURE_LIMIT_INCREASE]: 'esignature-limit-increase',
  [UpgradeProducts.WORKFLOWS_ADDON]: 'workflows-addon',
  [UpgradeProducts.WORKFLOWS_LIMIT_INCREASE]: 'workflows-limit-increase',
  [UpgradeProducts.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [UpgradeProducts.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [UpgradeProducts.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [UpgradeProducts.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [UpgradeProducts.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [UpgradeProducts.CRM_CONTACT_RECORDS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  [UpgradeProducts.MARKETING_SMS_SHORT_CODE]: 'marketing-sms-short-code',
  [UpgradeProducts.COMMERCE_PROFESSIONAL]: 'commerce-hub-professional',
  [UpgradeProducts.COMMERCE_ENTERPRISE]: 'commerce-hub-enterprise',
  [UpgradeProducts.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [UpgradeProducts.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise'
};
export const i18nKeysByApiName = {
  [FreeProducts.HUBSPOT_FREE]: 'hubspotFree',
  [FreeProducts.MARKETING_HUB_FREE]: 'hubspotFree',
  [FreeProducts.SALES_HUB_FREE]: 'hubspotFree',
  [FreeProducts.SERVICE_HUB_FREE]: 'hubspotFree',
  [FreeProducts.OPERATIONS_HUB_FREE]: 'hubspotFree',
  [FreeProducts.CMS_HUB_FREE]: 'hubspotFree',
  [Products.SALES_HUB_STARTER]: 'salesStarter',
  [Products.SALES_HUB_PROFESSIONAL]: 'salesPro',
  [Products.SALES_HUB_ENTERPRISE]: 'salesEnterprise',
  [Products.MARKETING_HUB_BASIC]: 'marketingBasic',
  [Products.MARKETING_HUB_STARTER]: 'marketingStarter',
  [Products.MARKETING_HUB_PROFESSIONAL]: 'marketingProfessional',
  [Products.MARKETING_HUB_ENTERPRISE]: 'marketingEnterprise',
  [Products.SERVICE_HUB_STARTER]: 'serviceStarter',
  [Products.SERVICE_HUB_PROFESSIONAL]: 'serviceProfessional',
  [Products.SERVICE_HUB_ENTERPRISE]: 'serviceEnterprise',
  [Products.OPERATIONS_HUB_STARTER]: 'operations-starter',
  [Products.OPERATIONS_HUB_PROFESSIONAL]: 'operations-professional',
  [Products.OPERATIONS_HUB_ENTERPRISE]: 'operations-enterprise',
  [Products.CMS_HUB_STARTER]: 'cmsStarter',
  [Products.CMS_HUB_PROFESSIONAL]: 'cmsProfessional',
  [Products.CMS_HUB_ENTERPRISE]: 'cmsEnterprise',
  [Products.CRM_SUITE_STARTER_BUNDLE]: 'crm-suite-starter-bundle',
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'crm-suite-professional-bundle',
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: 'crm-suite-enterprise-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: 'marketing-plus-professional-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: 'marketing-plus-enterprise-bundle',
  [Products.ADS_LIMIT_INCREASE]: 'ads',
  [Products.REPORTING_LIMIT_INCREASE]: 'reporting',
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: 'dedicatedIp',
  [Products.TRANSACTIONAL_EMAIL]: 'transactionalEmail',
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: 'customSsl',
  [Products.MARKETING_SMS]: 'marketing-sms',
  [Products.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [Products.DOMAINS_LIMIT_INCREASE]: 'domains-limit-increase',
  [Products.SANDBOX_LIMIT_INCREASE]: 'sandbox-limit-increase',
  [Products.CALLING_LIMIT_INCREASE]: 'calling-limit-increase',
  [Products.PHONE_LIMIT_INCREASE]: 'phone-limit-increase',
  [Products.TEAMS_LIMIT_INCREASE]: 'teams-limit-increase',
  [Products.WHATSAPP_LIMIT_INCREASE]: 'whatsapp-limit-increase',
  [Products.VIDEO_LIMIT_INCREASE]: 'video-limit-increase',
  [Products.ESIGNATURE_LIMIT_INCREASE]: 'esignature-limit-increase',
  [Products.WORKFLOWS_LIMIT_INCREASE]: 'workflows-limit-increase',
  [Products.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [Products.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: 'service-hub-professional-onboarding',
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: 'sales-hub-professional-onboarding',
  [Products.BREEZE_INTELLIGENCE_CREDITS_100]: 'breeze-intelligence-credits-100',
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000]: 'breeze-intelligence-credits-1000',
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000]: 'breeze-intelligence-credits-10000',
  [Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: 'breeze-intelligence-credits-100-committed',
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: 'breeze-intelligence-credits-1000-committed',
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: 'breeze-intelligence-credits-10000-committed',
  [Products.COMMERCE_HUB_PROFESSIONAL]: 'commerce-hub-professional',
  [Products.COMMERCE_HUB_ENTERPRISE]: 'commerce-hub-enterprise',
  [Products.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [Products.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise'
};
export const getProductNameTextFromApiName = apiName => {
  const productTitleKey = i18nKeysByApiName[apiName];
  if (!isValidI18nKey(`upgrades.products.${productTitleKey}`)) {
    trackFailedApiNameMap('getProductNameTextFromApiName', apiName, 'no upgrade product');
    return I18n.text('upgrades.products.default');
  }
  return I18n.text(`upgrades.products.${productTitleKey}`);
};
export const getProductNameText = upgradeProduct => {
  const productTitleKey = i18nKeysByUpgradeProduct[upgradeProduct];
  if (!isValidI18nKey(`upgrades.products.${productTitleKey}`)) {
    const errorMessage = `failed to get product name text from upgradeProduct ${upgradeProduct} in getProductNameText`;
    logRavenException({
      customMessage: errorMessage,
      error: Error(errorMessage),
      fingerprint: ['getProductNameText']
    });
    return I18n.text('upgrades.products.default');
  }
  return I18n.text(`upgrades.products.${productTitleKey}`);
};
export const getTranslatedProductName = (apiName, upgradeProduct) => {
  const defaultText = I18n.text('upgrades.products.default');
  const apiNameLanguageKey = `upgrades.products.${i18nKeysByApiName[apiName]}`;
  const upgradeProductLanguageKey = upgradeProduct && `upgrades.products.${i18nKeysByUpgradeProduct[upgradeProduct]}` || '';
  if (isValidI18nKey(apiNameLanguageKey)) {
    return I18n.text(apiNameLanguageKey);
  } else if (isValidI18nKey(upgradeProductLanguageKey)) {
    trackFailedApiNameMap('getProductNameTextFromApiName', apiName || 'undefined apiName', upgradeProduct);
    return I18n.text(upgradeProductLanguageKey);
  } else {
    const errorMessage = `failed to get product name text from upgradeProduct ${upgradeProduct} in getProductNameText`;
    logRavenException({
      customMessage: errorMessage,
      error: Error(errorMessage),
      fingerprint: ['getTranslatedProductName']
    });
    return defaultText;
  }
};